<template>
  <div></div>
</template>

<script>
import ax from "axios";
export default {
  data() {
    return {
      paymentData: {
        payerName: "",
        customerId: "",
        payerEmail: "",
        payerPhone: "",
        description: "",
        details: "",
        amount: "",
        serviceTypeId: "",
        paymentId: "",
        orderId: "",
        rrr: "",
      },
      checkRRRStatus: "",
      responseCheckRRR: "",
      url: "https://remitademo.net/remita/exapp/api/v1/send/api/echannelsvc/merchant/api/paymentinit",
      paymentObj: {
        serviceTypeId: "4430731",
        amount: "5000",
        orderId: `123454`,
        payerName: "here",
        payerEmail: "alozie@systemspecs.com.ng",
        payerPhone: "09062067384",
        description: "Payment for Donation 3",
        customField: [
          {
            name: "Matric Number",
            value: "1509329285795",
            type: "ALL",
          },
          {
            name: "Invoice Number",
            value: "1234",
            type: "ALL",
          },
        ],
      },
      remitaPaymentKey: null,
    };
  },
  methods: {
    async initTransaction() {
      return new Promise((res, rej) => {
        this.$store
          .dispatch("initTransaction", { payment: this.paymentData, gateway: this.paymentData.gateway || "interswitch" })
          .then((response) => {
            // value = response;
            this.paymentData.orderId = response.data.value.orderId;
            this.paymentData.rrr = response.data.value.rrr;
            res(response);
            // return value
            // this.$store.dispatch("hideGlobalSpinner");
          })
          .catch((err) => {
                this.$store.dispatch("hideGlobalSpinner");
          });
      });
    },

    async getRRR() {
      return new Promise((res, rej) => {
        axios
          .post("/generateRRR", {
            serviceType_id: this.paymentData.serviceTypeId,
            amount: this.paymentData.amount,
            orderId: this.paymentData.orderId,
            description: this.paymentData.description,
            details: this.paymentData.details,
          })
          .then((response) => {
            if (response.data.statuscode == "025" || response.data.msg == "success") {
              this.paymentData.rrr = response.data.RRR;
              res(response);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            Toast.fire({
              icon: "error",
              title: "Unable to get Remita retrieval reference",
            });
            rej(err);
          });
      });
    },

    async saveRRR() {
      return new Promise((res, rej) => {
        axios
          .post("/addRemitaRRR", this.paymentData)
          .then((response) => {
            if (response.data.msg == "success") {
              console.log("got RRRR");
              res(response);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    async makePayment() {
      const initTransaction = await this.initTransaction();

      if (this.paymentData.gateway === "interswitch" && initTransaction.data.interswitch) {
        this.$store
          .dispatch("interswitchPayment", {
            ...initTransaction.data.interswitch,
            payment_type: "APPLICATION",
          })
          .then((response) => {
            Fire.$emit("paymentComplete");
            this.$store.dispatch("hideGlobalSpinner");
          })
          .catch((err) => {
            if (err.message) {
              Toast.fire({ icon: "info", title: err.message });
            }
            this.$store.dispatch("hideGlobalSpinner");
          });
        return;
      }

      let RRRdata = "";
      if (initTransaction.data.type == "checkRRR") {
      } else {
        RRRdata = await this.getRRR();
      }
      await this.saveRRR();

      try {
        if (!this.remitaPaymentKey) {
          const keyRes = await axios.get("/remitaPaymentKey");
          this.remitaPaymentKey = keyRes.data.key;
        }
        let amount = this.paymentData.amount;
        var paymentEngine = RmPaymentEngine.init({
          key: this.remitaPaymentKey,
          customerId: this.paymentData.customerId,
          firstName: this.paymentData.firstName,
          lastName: this.paymentData.lastName,
          email: this.paymentData.email,
          narration: this.paymentData.narration,
          amount: this.paymentData.amount,
          processRrr: true,
          extendedData: {
            customFields: [
              {
                name: "rrr",
                value: this.paymentData.rrr,
              },
            ],
          },
          onSuccess: (response) => {
            response = { ...this.paymentData, ...response };
            Fire.$emit("remitaSuccess", response);
            this.$store.dispatch("hideGlobalSpinner");
          },
          onError: (response) => {
            response = { ...response, ...this.paymentData };
            Fire.$emit("remitaFail", response);
            this.$store.dispatch("hideGlobalSpinner");
          },
          onClose: () => {
            this.$store.dispatch("hideGlobalSpinner");
          },
        });

        paymentEngine.showPaymentWidget();
      } catch (error) {
        this.$store.dispatch("hideGlobalSpinner");
        Toast.fire({
          icon: "error",
          title: "Connection to remita failed",
        });
      }
    },
    async checkRRR(details, index) {
      return new Promise(async (res, rej) => {
        axios
          .post("checkRRRStatus", { rrr: details.rrr })
          .then(async (response) => {
            await this.checkAndUpdatePayment(response.data, details);
            Fire.$emit(
              "remitaCheckRRRStatusResponse",
              response.data,
              index,
              details
            );
            res(true);
          })
          .catch((err) => {
            Fire.$emit("remitaCheckRRRStatusResponse");
            rej(false);
          });
      });
    },
    //working here2
    async checkAndUpdatePayment(response, details) {
      return new Promise(async (res, rej) => {
        try {
          if (response.status == "02") {
            await this.updatePaymentStatus(details, "FAILED", response);
          } else if (response.status == "00" || response.status == "01") {
            await this.updatePaymentStatus(details, "SUCCESS", response);
          } else if (response.status == "021") {
            if (details.status == "pending") {
            } else {
              await this.updatePaymentStatus(details, "PENDING", response);
            }
          }
          res(true);
        } catch (error) {
          rej(false);
        }
      });
    },
    updatePaymentStatus(payment, status, remitaResponse) {
      return new Promise((res, rej) => {
        axios
          .post("updatePaymentStatus", {
            payment: payment,
            status: status,
            remitaResponse: remitaResponse,
          })
          .then((response) => {
            res(true);
          })
          .catch((err) => {
            rej(false);
          });
      });
    },
  },
  mounted() {
    // let externalScript = document.createElement("script");
    // externalScript.setAttribute(
    //   "src",
    //   "http://www.login.remita.net/payment/v1/remita-pay-inline.bundle.js"
    // );
    // document.head.appendChild(externalScript);
  },
  created() {
    Fire.$on("remitaCheckRRRStatus", (data, index) => {
      this.checkRRR(data, index);
    });
    Fire.$on("remitaPayment", (data) => {
      this.paymentData = data;
      this.makePayment();
    });
  },
  beforeDestroy() {
    // Clean up all event listeners
    Fire.$off("remitaCheckRRRStatus");
    Fire.$off("remitaPayment");
  },
};
</script>

<style></style>
